import { useMutation, useQuery } from "@tanstack/react-query";
import { handleError } from "@/api/error";
import { startImpersonation } from "@/lib/impersonation";
import { client } from "../client";

export const useImpersonationTargets = (text: string, enabled = true) => {
  return useQuery({
    queryKey: ["admin", "impersonation", "users", text],
    enabled,
    queryFn: async () => {
      const res = await client.admin.impersonation.users.$get({ query: { text, limit: "50" } });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
  });
};

export const useImpersonateUser = () => {
  return useMutation({
    mutationFn: async (payload: { id: string }) => {
      const res = await client.admin.impersonation.users[":id"].$post({ param: { id: payload.id } });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    onSuccess: (user) => {
      startImpersonation(user.id);
    },
  });
};
